var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"d-flex align-center",attrs:{"cols":"12"}},[(_vm.icon)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.colors.base},domProps:{"textContent":_vm._s(_vm.icon)}}):_vm._e(),_c('v-subheader',{staticClass:"pa-0 helmi-subheader",class:_vm.colors.text,domProps:{"textContent":_vm._s(_vm.$attrs.label)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }